import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from './core/core.module';
import { RouterModule } from '@angular/router';
import { WidgetModule } from '../../web/components/widget/widget.module';
import { ModalSegurosComponent } from './modules/Components/modals-seguros.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule, //Core Seguros
    RouterModule,
    WidgetModule
  ],
  declarations: [
    ModalSegurosComponent
  ]
})
export class SegurosModule { }
